// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__oI0qR","right":"styles_right__2h4pt"};